import { Message, Loading } from 'element-ui';
import axios from '@/management/api/base';

// 通用下载方法
// 定义方法  main.js  全局挂载
export function download(fileName, url) {
  axios({
    method: 'get',
    url: url,
    responseType: 'blob',
  })
    .then((data) => {
      if (!data) {
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '下载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let url = window.URL.createObjectURL(new Blob([data]));
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      loading.close();
    })
    .catch((error) => {
      throw error;
    });
}
